export const lightest_gray = "#e6eaed";
export const light_gray = "#b0b2b5"
export const medium_gray = "#74787d";
export const dark_gray = "#4c4c4d";
export const darkest_gray = "#2f2f30";
export const white = "#ffffff";
export const black = "#000000";
export const dark_aqua = "#0b6787";
export const dark_green = "#035E5B";
export const grey_green = "#a1bfbe";